var _path, _path2, _circle, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGood(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.63135 22.4685C8.90087 22.3713 8.96958 22.58 9.05848 22.7579C8.89688 22.6907 8.75918 22.5871 8.63135 22.4685Z",
    fill: "#BAD46B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0506 0.122674C13.957 0.218696 13.8272 0.186989 13.7158 0.220104C13.8078 0.118112 13.8545 -0.14433 14.0506 0.122674Z",
    fill: "#FCFEE6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "#B5D855"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7291 18.5096C11.0764 18.4662 9.59227 17.946 8.27886 16.9319C8.06763 16.7688 7.87646 16.5773 7.68591 16.3886C7.49142 16.1959 7.47789 15.9696 7.63406 15.8032C7.80304 15.6233 7.98865 15.6368 8.20605 15.853C9.14633 16.7875 10.2705 17.3822 11.5535 17.6347C12.7809 17.8762 13.9861 17.7344 15.1492 17.2575C15.9124 16.9445 16.5934 16.5048 17.1762 15.9119C17.2152 15.8723 17.254 15.8304 17.2995 15.8C17.5136 15.6578 17.7662 15.66 17.8614 15.8182C17.9879 16.0284 17.9466 16.2045 17.7659 16.3876C16.6672 17.5008 15.3488 18.1571 13.8174 18.3791C13.4558 18.4316 13.0919 18.4665 12.7291 18.5096Z",
    fill: "#4E6302"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3794 10.4491C16.3796 9.74091 16.9257 9.2006 17.6407 9.20105C18.3265 9.20156 18.872 9.75483 18.8745 10.4526C18.8771 11.1829 18.3317 11.7334 17.6043 11.7345C16.9074 11.7355 16.3792 11.1812 16.3794 10.4491Z",
    fill: "#4F6302"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.61976 10.4419C6.51711 9.82316 7.17561 9.1764 7.84116 9.19583C8.56477 9.21695 9.09239 9.72584 9.09672 10.4621C9.10077 11.1582 8.63598 11.7212 7.82274 11.7337C7.20511 11.7432 6.54755 11.2233 6.61976 10.4419Z",
    fill: "#4F6302"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGood);
export default __webpack_public_path__ + "static/media/good.b33cb583365683cfae014ad060d3f6e3.svg";
export { ForwardRef as ReactComponent };